module.exports = __webpack_public_path__ + "img/av256.34c867f4.png";